<script>
import ButtonLoader from '@src/components/loader/button-loader.vue'
import '@src/design/components/login-layout.scss'
import { baseComputed } from '@state/helpers/base.js'

export default {
    components: {
        'button-loader': ButtonLoader,
    },
    computed: {
        ...baseComputed,
    },
}
</script>

<template>
    <div>
        <b-container fluid>
            <button-loader :active="isLoading"></button-loader>
            <b-row class="login ">
                <slot />
                <b-col sm="12" md="8" class="login__imageArea">
                    <b-row align-v="end">
                        <b-col class="login__imageArea__msgBox">
                            <h2 class="login__imageArea__msgBox__phrase">
                                <span
                                    class="login__imageArea__msgBox__quotation"
                                    >“</span
                                >
                                {{ $t('Login.quote') }}
                            </h2>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" module>
@import '@design';
</style>
